export default __webpack_public_path__ + "static/media/gym.77b96795.jpg";